/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2025-08-24 21:27:23
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-03-14 21:35:04
 * @FilePath: \利享乡村管理后台\src\api\ApiJson\ApiOrder.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import config from '../nyConfig'
const ApiOrder = {
    "土地预约列表": new config({url: '/land/reservation/pageDateAdmin', showSuccessMessage: false, useToken: true }),
    "民宿预约列表": new config({url: '/homestay/reservation/pageDateAdmin', showSuccessMessage: false, useToken: true }),
    "用户支付列表": new config({url: '/manager/order/orderList', showSuccessMessage: false, useToken: true }),
}
export default ApiOrder